import type { Organization } from '@/features/organization/types';
import type { Role } from '@/app/store/session.store';
import type { WorkloadStatus } from '@/shared/ui/molecules/StatusPill/status';

export type MemberSummary = {
  id: string;
  email: string;
  displayName: string;
  initials: string;
  avatarColor: string;
  jobTitle: string | null;
  role: Role;
  status: 'INVITED' | 'ACTIVE' | 'DISABLED';
  weeklyCapacityHours: number;
  availabilityNote: string | null;
  workloadStatus: WorkloadStatus;
  avatarUrl?: string | null;
  roleId?: string | null;
  roleName?: string | null;
  departmentId?: string | null;
  departmentName?: string | null;
  memberTypeId?: string | null;
  memberTypeName?: string | null;
  contractTypeId?: string | null;
  contractTypeName?: string | null;
};
export type RoleKind = 'ADMIN' | 'MANAGER' | 'MEMBER' | 'CUSTOM';
export type RoleView = { id: string; name: string; description: string | null; kind: RoleKind; permissions: string[]; editable: boolean; deletable: boolean; members: number; version: number };
export type PermissionView = { code: string; module: string };
export type RoleInput = { name: string; description?: string | null; permissions: string[]; version?: number };
/** The signed-in organisation: its descriptive fields plus plan and workspace settings. */
export type TenantInfo = Organization & { plan: string; settings: Record<string, unknown> };
export type Invitation = { id: string; tenantId: string; email: string; role: Role; displayName: string | null; jobTitle: string | null; expiresAt: string; createdAt: string; inviteUrl: string | null; emailDelivered?: boolean | null };

/** A department with its area lead (a member, not necessarily an administrator). */
export type Department = { id: string; name: string; leadUserId: string; leadName: string | null; members: number };

/** An entry of the organisation's job title catalogue. */
export type JobTitle = { id: string; name: string };

/** The member catalogues each organisation maintains (informative classification of members). */
export type CatalogKind = 'member-types' | 'contract-types';
export type CatalogEntry = { id: string; name: string };

/** ISO weekdays as the server names them. */
export type Weekday = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
export const WEEKDAYS: Weekday[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

/** One colour of the report palette; the seven positions are roles (primary, primary dark, pattern, accent,
 * accent dark, accent light, base). */
export type ReportColor = { name: string; hex: string };
